export default __webpack_public_path__ + "maps-examples-source-custom-raster-thumbnail-960-3c114f7cf4a98a3ba0b97ae470d83191.png";